import httpClient from '@/services/httpClient'
import type { INPS, INPSRequest, SaveResolvabilityParams } from './types'

export const saveNPS = async (
  consultationId: string,
  nps: INPS,
): Promise<boolean> => {
  const requestBody: INPSRequest = {
    idAtendimento: Number(consultationId),
    avaliaProfissional: nps.professionalEvaluation,
    ...(nps.professionalEvaluation && {
      medico: {
        avaliacao: nps.professional.rating,
        comentario: nps.professional.comment || '',
        detalhes: nps.professional.details || [],
        nps: nps.professional.nps,
      },
      plataforma: {
        avaliacao: nps.platform.rating,
        comentario: nps.platform.comment || '',
        detalhes: nps.platform.details || [],
        nps: nps.platform.nps,
      },
    }),
    ...(!nps.professionalEvaluation && {
      atendimentoSemChamada: {
        comentario: nps.appointmentWithoutCall.comment,
        motivo: nps.appointmentWithoutCall.reason,
      },
      plataforma: {
        avaliacao: nps.platform.rating,
        comentario: nps.platform.comment || '',
        detalhes: nps.platform.details || [],
        nps: nps.platform.nps,
      },
    }),
  }

  const response = await httpClient.post(
    '/integration/app-paciente/avaliacao-atendimento/salvar',
    requestBody,
  )

  return response?.data?.object || false
}

export const unansweredNps = async (): Promise<void> => {
  await httpClient.get('/integration/app-paciente/nps/naorespondido')
}

export const saveResolvability = async (
  params: SaveResolvabilityParams,
): Promise<void> => {
  const { consultationId, consultationReason, wasResolutive } = params

  await httpClient.post(
    '/integration/app-paciente/atendimento/salvar-satisfacao-paciente',
    {
      idAtendimento: consultationId,
      motivoConsulta: consultationReason,
      atendimentoResolutivo: wasResolutive,
    },
  )
}
